export const queryKeys = {
  all: ['mb'] as const,

  profile: (userId: string) => [...queryKeys.all, 'profile', userId] as const,
  stats: (userId: string) => [...queryKeys.all, 'stats', userId] as const,
  preferences: (userId: string) => [...queryKeys.all, 'preferences', userId] as const,

  releases: () => [...queryKeys.all, 'releases'] as const,
  release: (version: string) => [...queryKeys.all, 'releases', version] as const,
  latestRelease: (channel: string) =>
    [...queryKeys.all, 'releases', 'latest', channel] as const,
} as const;
